import { render } from "./Inventory_process_button.vue?vue&type=template&id=4eba65e8&scoped=true"
import script from "./Inventory_process_button.vue?vue&type=script&lang=js"
export * from "./Inventory_process_button.vue?vue&type=script&lang=js"

import "./Inventory_process_button.vue?vue&type=style&index=0&id=4eba65e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eba65e8"]])

export default __exports__